<template>
  <div>
    <v-dialog persistent v-model="show" max-width="1000">
      <v-card>
        <v-card-title class="headline">Generar documentos</v-card-title>
        <v-card-text>
          {{ retornaQuienApareceEnDocumento }}
          <v-checkbox
            v-if="1 == 2"
            v-model="remitenteTitularDocumento"
            label="Remitente es titular de documento"
          ></v-checkbox>
          <!-- este div solo se debe mostrar si el remitente es titular, 
          ya que si no no se ocupa su nombre del remitente tampoco -->
          <div v-if="1 == 2">
            <div v-if="direcciones.length == 1">
              Dirección de documento:
              {{ direcciones[0].estado }} <br />
              {{ direcciones[0].colonia }} <br />
              {{ direcciones[0].direccion }} <br />
              {{ direcciones[0].municipio }} <br />
              {{ direcciones[0].codigopostal }} <br />
            </div>
            <div v-if="direcciones.length > 1">
              Dirección de documento:{{ direccionElegida.estado }} <br />
              {{ direccionElegida.colonia }} <br />
              {{ direccionElegida.direccion }} <br />
              {{ direccionElegida.municipio }} <br />
              {{ direccionElegida.codigopostal }} <br />
              <v-data-table
                @click:row="rowClick"
                hide-default-footer
                :headers="headers"
                :items="direcciones"
                single-select
                item-key="indice"
              >
              </v-data-table>
            </div>
          </div>
          <v-container fluid>
            <v-row no-gutters v-if="1 == 2">
              <v-col cols="12">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  dense
                  autofocus
                  @input="buscarClienteMostrador()"
                  v-model="search"
                  label="Búsqueda..."
                  single-line
                  solo
                  clearable
                ></v-text-field>

                <v-data-table
                  @click:row="rowClick2"
                  hide-default-footer
                  :headers="headers3"
                  :items="remitentesMostradorList"
                  single-select
                  item-key="ID"
                >
                </v-data-table>
                <v-data-table
                  v-if="listaDireccionesMayorAUno.length > 0"
                  @click:row="rowClick3DireccionLista"
                  hide-default-footer
                  :headers="headers2"
                  :items="listaDireccionesMayorAUno"
                  single-select
                  item-key="id"
                >
                </v-data-table>
              </v-col>
            </v-row>
            <v-row no-gutters>
              CERTIFICADOR: {{ queTipoEsUsuarioTMEC }}
              <v-radio-group v-model="queTipoEsUsuarioTMEC" row>
                <v-radio label="Importador" value="Importador"></v-radio>
                <v-radio label="Exportador" value="Exportador"></v-radio>
                <v-radio label="Productor" value="Productor"></v-radio>
              </v-radio-group>
            </v-row>
            <!-- empieza renglon productor lado izquierdo -->
            <v-row no-gutters>
              <v-col cols="6">
                Detalles del productor
                <div style="display:inline-flex;">
                  <v-checkbox
                    :disabled="deshabilitarVariosProductores || checkboxDisponibleAutoridades"
                    v-model="checkboxVariosProductores"
                    label="Varios productores"
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="checkboxVariosProductores"
                    v-model="checkboxDisponibleAutoridades"
                    label="Disponible a solicitud de las autoridades importadoras"
                  ></v-checkbox>
                </div>
              </v-col>
              <!-- importador lado derecho -->
              <v-col cols="6">
                Detalles del importador<br />
                <div style="display:inline-flex;">
                  <v-checkbox
                    :disabled="checkboxVariosImportadores"
                    v-model="checkboxImportadorDesconocidos"
                    label="Desconocidos"
                  ></v-checkbox>
                  <v-checkbox
                    :disabled="checkboxImportadorDesconocidos"
                    v-model="checkboxVariosImportadores"
                    label="Varios importadores"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
            <!-- termina renglon -->
            <v-row no-gutters v-if="queTipoEsUsuarioTMEC != 'Productor'">
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      label="NOMBRE DEL PRODUCTOR"
                      v-model.trim="productor.nombre"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field
                      outlined
                      dense
                      label="DOMICILIO DEL PRODUCTOR"
                      v-model.trim="productor.domicilio"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="4">
                    <v-text-field
                      outlined
                      dense
                      label="TELEFONO DEL PRODUCTOR"
                      v-model.trim="productor.telefono"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      outlined
                      dense
                      label="CORREO DEL PRODUCTOR"
                      v-model.trim="productor.correo"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      outlined
                      dense
                      label="RFC DEL PRODUCTOR"
                      v-model.trim="productor.rfc"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="TAX ID REMITENTE"
                  v-model.trim="taxIDRemitente"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  label="TAX ID DESTINATARIO"
                  v-model.trim="taxIDDestinatario"
                ></v-text-field
              ></v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="$emit('cerrarModalDocumentacion')" text
            >Cancelar</v-btn
          >
          <v-btn
            :disabled="deshabilitarBtnAceptar"
            color="blue darken-1"
            @click="aceptarPrevioDocumentos()"
            text
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
export default {
  data: () => ({
    queTipoEsUsuarioTMEC: "",
    checkboxImportadorDesconocidos: true,
    checkboxVariosProductores: false,
    checkboxVariosImportadores: false,
    checkboxDisponibleAutoridades: false,
    direccionLista3: -1,
    search: "",
    listaDireccionesMayorAUno: [],
    remitenteTitularDocumento: true,
    remitenteTitularSeleccioando: -1,
    headers: [
      {
        text: "direccion",
        align: "center",
        sortable: false,
        value: "direccion"
      },
      {
        text: "estado",
        align: "center",
        sortable: false,
        value: "estado"
      },
      {
        text: "colonia",
        align: "center",
        sortable: false,
        value: "colonia"
      },

      {
        text: "municipio",
        align: "center",
        sortable: false,
        value: "municipio"
      },
      {
        text: "codigopostal",
        align: "center",
        sortable: false,
        value: "codigopostal"
      }
    ],
    headers3: [
      {
        text: "Nombre",
        align: "center",
        sortable: false,
        value: "NOMBRE_COMPLETO"
      },
      {
        text: "Teléfono",
        align: "center",
        sortable: false,
        value: "TELEFONO"
      },
      {
        text: "Dirección",
        align: "center",
        sortable: false,
        value: "DIRECCION"
      },
      {
        text: "Sucursal",
        align: "center",
        sortable: false,
        value: "SUCURSAL"
      }
    ],
    headers2: [
      {
        text: "Nombre",
        align: "center",
        sortable: false,
        value: "colonia"
      },
      {
        text: "Teléfono",
        align: "center",
        sortable: false,
        value: "direccion"
      }
    ],

    queTipoEsUsuarioTMEC: "Productor",
    productor: {
      nombre: "",
      domicilio: "",
      telefono: "",
      correo: "",
      rfc: ""
    },
    deshabilitarBtnAceptar: false,
    titularDocumento: "",
    taxIDDestinatario: "",
    taxIDRemitente: "",
    direccionElegida: ""
  }),
  props: {
    show: Boolean
  },
  methods: {
    ...mapActions("enviosRemitentes", ["getInfoEnvioRemitente"]),
    ...mapActions("documentosInternacional", ["chargeInfoDespuesDocumento"]),
    ...mapActions("remitentesRegistro", ["getRemitenteMostrador", "destroyRemitentesMostrador"]),
    rowClick2(item, row) {
      row.select(true);
      this.remitenteTitularSeleccioando = item;
      if (this.remitenteTitularSeleccioando.DIRECCION.length >= 1) {
        const dirRemSelec = Array.from(JSON.parse(this.remitenteTitularSeleccioando.DIRECCION));
        const colRemSelec = Array.from(JSON.parse(this.remitenteTitularSeleccioando.COLONIA));
        const cpRemSelec = Array.from(JSON.parse(this.remitenteTitularSeleccioando.CODIGO_POSTAL));
        const estRemSelec = Array.from(JSON.parse(this.remitenteTitularSeleccioando.ESTADO));
        const ciuRemSelec = Array.from(JSON.parse(this.remitenteTitularSeleccioando.MUNICIPIO));
        //const dirRemSelec = Array.from(JSON.parse(this.remitenteTitularSeleccioando.DIRECCION));
        if (dirRemSelec.length >= 1) {
          this.listaDireccionesMayorAUno = [];
          for (let i = 0; i < dirRemSelec.length; i++) {
            this.listaDireccionesMayorAUno.push({
              direccion: dirRemSelec[i],
              ciudad: ciuRemSelec[i],
              estado: estRemSelec[i],
              cp: cpRemSelec[i],
              colonia: colRemSelec[i],
              id: i
            });
          }
          console.log(this.listaDireccionesMayorAUno);
        } else {
          this.listaDireccionesMayorAUno = [];
        }
      }
    },
    async consultaRem() {
    // consultaRem: _.debounce(async function() {
      await this.getInfoEnvioRemitente(this.infoTMECID);
      this.taxIDDestinatario = this.taxIDDestinatarioVUEX;
      this.taxIDRemitente = this.taxIDRemitenteVUEX;
    // }, 100),
    },
    asignaPrimerDireccion: _.debounce(async function() {
      if (this.direcciones.length > 1) {
        //si la longitud de direcciones es mayor a 1, se asigna la primera por default
        this.direccionElegida = this.direcciones[0];
      }
      //asigna taxid
      this.taxIDDestinatario = this.taxIDDestinatarioVUEX;
      this.taxIDRemitente = this.taxIDRemitenteVUEX;
    }, 300),
    rowClick(item, row) {
      row.select(true);
      this.direccionElegida = item;
    },
    rowClick3DireccionLista(item, row) {
      row.select(true);
      console.log(item.id);
      this.direccionLista3 = item;
    },
    buscarClienteMostrador: _.debounce(async function() {
      //this.loaderModalClientes = true;
      const resR = await this.getRemitenteMostrador(this.cadenaBusqueda);
      if (resR[0]) {
        //this.loaderModalClientes = false;
      }
    }, 400),
    async aceptarPrevioDocumentos() {
      // TODO ESTO SE VE SIMPLIFICADO CON EL NUEVO CAMBIO PEDIDO
      if (this.objetoPosteriorConInfo.direccionRemitente) {
        if (this.objetoPosteriorConInfo.direccionRemitente.direccion.length > 1) {
          await this.chargeInfoDespuesDocumento({
            DIRECCION: `${this.objetoPosteriorConInfo.direccionRemitente.direccion.toUpperCase()} ${this.objetoPosteriorConInfo.direccionRemitente.colonia.toUpperCase()} ${this.objetoPosteriorConInfo.direccionRemitente.codigopostal.toUpperCase()} ${this.objetoPosteriorConInfo.direccionRemitente.municipio.toUpperCase()} ${this.objetoPosteriorConInfo.direccionRemitente.estado.toUpperCase()}`,
            TAXIDREMITENTE: this.taxIDRemitente,
            TAXIDDESTINATARIO: this.taxIDDestinatario,
            TITULARDOCUMENTO: this.retornaQuienApareceEnDocumento,
            TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
            DATOSPRODUCTOR: this.productor,
            VALORESCHECKBOX: {
              VARIOSIMPORTADORES: this.checkboxVariosImportadores,
              IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
              DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
              VARIOSPRODUCTORES: this.checkboxVariosProductores
            }
          });
        } else {
          await this.chargeInfoDespuesDocumento({
            DIRECCION: null,
            TAXIDREMITENTE: this.taxIDRemitente,
            TAXIDDESTINATARIO: this.taxIDDestinatario,
            TITULARDOCUMENTO: this.retornaQuienApareceEnDocumento,
            TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
            DATOSPRODUCTOR: this.productor,
            VALORESCHECKBOX: {
              VARIOSIMPORTADORES: this.checkboxVariosImportadores,
              IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
              DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
              VARIOSPRODUCTORES: this.checkboxVariosProductores
            }
          });
        }
      }

      // if (this.remitenteTitularDocumento) {
      //   if (this.direcciones.length == 1) {
      //     this.chargeInfoDespuesDocumento({
      //       DIRECCION: `${this.direcciones[0].direccion.toUpperCase()} ${this.direcciones[0].colonia.toUpperCase()} ${this.direcciones[0].codigopostal.toUpperCase()} ${this.direcciones[0].municipio.toUpperCase()} ${this.direcciones[0].estado.toUpperCase()}`,
      //       TAXIDREMITENTE: this.taxIDRemitente,
      //       TAXIDDESTINATARIO: this.taxIDDestinatario,
      //       TITULARDOCUMENTO: this.titularDocumento.toUpperCase(),
      //       TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
      //       DATOSPRODUCTOR: this.productor,
      //       VALORESCHECKBOX: {
      //         VARIOSIMPORTADORES: this.checkboxVariosImportadores,
      //         IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
      //         DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
      //         VARIOSPRODUCTORES: this.checkboxVariosProductores
      //       }
      //     });
      //     // si es igual a cero entonces como no hay direccion mandamos cadena vacia como direccion
      //   } else if (this.direcciones.length == 0) {
      //     this.chargeInfoDespuesDocumento({
      //       DIRECCION: "",
      //       TAXIDREMITENTE: this.taxIDRemitente,
      //       TAXIDDESTINATARIO: this.taxIDDestinatario,
      //       TITULARDOCUMENTO: this.titularDocumento.toUpperCase(),
      //       TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
      //       DATOSPRODUCTOR: this.productor,
      //       VALORESCHECKBOX: {
      //         VARIOSIMPORTADORES: this.checkboxVariosImportadores,
      //         IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
      //         DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
      //         VARIOSPRODUCTORES: this.checkboxVariosProductores
      //       }
      //     });
      //     //si es diferente de cero o uno entonces es arreglo y hay que obtener la que se eligió
      //   } else {
      //     this.chargeInfoDespuesDocumento({
      //       DIRECCION: `${this.direccionElegida.direccion.toUpperCase()} ${this.direccionElegida.colonia.toUpperCase()} ${this.direccionElegida.codigopostal.toUpperCase()} ${this.direccionElegida.municipio.toUpperCase()} ${this.direccionElegida.estado.toUpperCase()}`,
      //       TAXIDREMITENTE: this.taxIDRemitente,
      //       TAXIDDESTINATARIO: this.taxIDDestinatario,
      //       TITULARDOCUMENTO: this.titularDocumento.toUpperCase(),
      //       TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
      //       DATOSPRODUCTOR: this.productor,
      //       VALORESCHECKBOX: {
      //         VARIOSIMPORTADORES: this.checkboxVariosImportadores,
      //         IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
      //         DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
      //         VARIOSPRODUCTORES: this.checkboxVariosProductores
      //       }
      //     });
      //   }
      // } else {
      //   //esta seccion es para cuando el remitente no es el titular del documento
      //   //  osea que seleccionaron o van a a seleccionar alguien mas desde el menu
      //   if (this.listaDireccionesMayorAUno.length == 0) {
      //     this.chargeInfoDespuesDocumento({
      //       DIRECCION: "",
      //       TAXIDREMITENTE: this.taxIDRemitente,
      //       TAXIDDESTINATARIO: this.taxIDDestinatario,
      //       TITULARDOCUMENTO: this.remitenteTitularSeleccioando.NOMBRE_COMPLETO.toUpperCase(),
      //       TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
      //       DATOSPRODUCTOR: this.productor,
      //       VALORESCHECKBOX: {
      //         VARIOSIMPORTADORES: this.checkboxVariosImportadores,
      //         IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
      //         DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
      //         VARIOSPRODUCTORES: this.checkboxVariosProductores
      //       }
      //     });
      //   } else if (this.listaDireccionesMayorAUno.length == 1) {
      //     this.chargeInfoDespuesDocumento({
      //       DIRECCION: `${this.listaDireccionesMayorAUno[0].direccion.toUpperCase()} ${this.listaDireccionesMayorAUno[0].colonia.toUpperCase()} ${this.listaDireccionesMayorAUno[0].cp.toUpperCase()} ${this.listaDireccionesMayorAUno[0].ciudad.toUpperCase()} ${this.listaDireccionesMayorAUno[0].estado.toUpperCase()}`,
      //       TAXIDREMITENTE: this.taxIDRemitente,
      //       TAXIDDESTINATARIO: this.taxIDDestinatario,
      //       TITULARDOCUMENTO: this.remitenteTitularSeleccioando.NOMBRE_COMPLETO.toUpperCase(),
      //       TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
      //       DATOSPRODUCTOR: this.productor,
      //       VALORESCHECKBOX: {
      //         VARIOSIMPORTADORES: this.checkboxVariosImportadores,
      //         IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
      //         DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
      //         VARIOSPRODUCTORES: this.checkboxVariosProductores
      //       }
      //     });
      //   } else if (this.listaDireccionesMayorAUno.length > 1) {
      //     this.chargeInfoDespuesDocumento({
      //       DIRECCION: `${this.listaDireccionesMayorAUno[
      //         this.direccionLista3.id | 0
      //       ].direccion.toUpperCase()} ${this.listaDireccionesMayorAUno[
      //         this.direccionLista3.id | 0
      //       ].colonia.toUpperCase()} ${this.listaDireccionesMayorAUno[
      //         this.direccionLista3.id | 0
      //       ].cp.toUpperCase()} ${this.listaDireccionesMayorAUno[
      //         this.direccionLista3.id | 0
      //       ].ciudad.toUpperCase()} ${this.listaDireccionesMayorAUno[
      //         this.direccionLista3.id | 0
      //       ].estado.toUpperCase()}`,
      //       TAXIDREMITENTE: this.taxIDRemitente,
      //       TAXIDDESTINATARIO: this.taxIDDestinatario,
      //       TITULARDOCUMENTO: this.remitenteTitularSeleccioando.NOMBRE_COMPLETO.toUpperCase(),
      //       TIPOUSUARIOTMEC: this.queTipoEsUsuarioTMEC.toUpperCase(),
      //       DATOSPRODUCTOR: this.productor,
      //       VALORESCHECKBOX: {
      //         VARIOSIMPORTADORES: this.checkboxVariosImportadores,
      //         IMPORTADORDESCONOCIDO: this.checkboxImportadorDesconocidos,
      //         DISPONIBLEAUTORIDADESIMPORTADORAS: this.checkboxDisponibleAutoridades,
      //         VARIOSPRODUCTORES: this.checkboxVariosProductores
      //       }
      //     });
      //   }
      // }

      this.$emit("aceptarModalDocumentacion");
    },
    async deshabilitarBotonAceptarJaJa() {
      this.deshabilitarBtnAceptar = false;
      this.deshabilitarBtnAceptar = false;
    }
  },
  computed: {
    ...mapState("documentosInternacional", {
      infoTMECID: state => state.infoDocumentoTMEC.idRemitente,
      taxIDDestinatarioVUEX: state => state.infoDocumentoTMEC.taxIDDestinatario,
      objetoPosteriorConInfo: state => state.objetoPosteriorConInfo
    }),
    ...mapState("remitentesRegistro", {
      remitentesMostradorList: state => state.remitentesMostrador
    }),
    ...mapState("enviosRemitentes", {
      direcciones: state => state.infoOneRemitente.DIRECCION,
      taxIDRemitenteVUEX: state => state.infoOneRemitente.TAXID,
      nombreRemitenteObtenidoSEgundaOpcion: state => state.infoOneRemitente.NOMBRE_COMPLETO
    }),
    cadenaBusqueda() {
      return this.search == null ? "" : this.search;
    },
    retornaQuienApareceEnDocumento() {
      if (
        this.objetoPosteriorConInfo.remitenteDelEnvioTitular != "" &&
        this.objetoPosteriorConInfo.remitenteDelEnvioTitular != null
      ) {
        return this.objetoPosteriorConInfo.remitenteDelEnvioTitular.toUpperCase() + "";
      } else {
        return this.nombreRemitenteObtenidoSEgundaOpcion.toUpperCase() + "";
      }
    },
    deshabilitarVariosProductores() {
      if (this.queTipoEsUsuarioTMEC == "Productor") {
        return true;
      } else {
        return false;
      }
    }
  },
  async beforeMount(){
await this.consultaRem();
  },

  async mounted() {
    // console.error("idremitente", this.infoTMEC.idRemitente);
    // console.log(this.infoTMECID);
    //await this.buscarClienteMostrador();

    //TODOLas siguientes dos lineas ya no se usan ya que ahora la informacion
    //de remitente viene desde la base de datos
    

    // await this.asignaPrimerDireccion();

    //await this.deshabilitarBotonAceptarJaJa();
  }
};
</script>
<style lang="css">
tr.v-data-table__selected {
  background: #7d92f5 !important;
  color: white !important;
  font-weight: bold !important;
}
.v-data-table .v-data-table__mobile-table-row {
  display: block !important;
}
</style>
